<script lang="ts">
	import { onMount } from 'svelte'

	interface Props {
		history: number[]
		maxHeight?: number
		barWidth?: number
		gap?: number

		/** notify parent how many bars fit */
		onCapacityChange?: (capacity: number) => void
	}

	let { history, maxHeight = 32, barWidth = 3, gap = 3, onCapacityChange }: Props = $props()

	let container: HTMLDivElement | null = null

	function calculateCapacity(width: number) {
		const barTotal = barWidth + gap
		if (barTotal <= 0) return 0
		return Math.max(1, Math.floor(width / barTotal))
	}

	onMount(() => {
		if (!container || !onCapacityChange) return

		const observer = new ResizeObserver((entries) => {
			const entry = entries[0]
			const width = entry.contentRect.width
			onCapacityChange(calculateCapacity(width))
		})

		observer.observe(container)

		return () => observer.disconnect()
	})
</script>

<div
	bind:this={container}
	class="voice-history"
	style={`--h:${maxHeight}px; --gap:${gap}px`}
	aria-hidden="true"
>
	{#each history as value}
		<span
			class="bar"
			style={`
        width:${barWidth}px;
        height:${Math.max(4, Math.pow(value, 0.4) * maxHeight)}px;
      `}
		/>
	{/each}
</div>

<style>
	.voice-history {
		@apply w-full;
		display: flex;
		align-items: center;
		gap: var(--gap);
		height: var(--h);
		overflow: hidden;
	}

	.bar {
		background: #002c4d80;
		border-radius: 16px;
		transition: height 140ms cubic-bezier(0.4, 0, 0.2, 1);
	}
</style>
